export default __webpack_public_path__ + "static/media/linearEqSys.4cb93681.jpeg";